<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <div class="nav-list">
            <div class="nav">
              <div class="nav__item">
                <div @click="scrollToSection('home')" class="desc hover-link">
                  Home
                </div>
              </div>
              <div class="nav__item">
                <div @click="scrollToSection('about')" class="desc hover-link">
                  About Us
                </div>
              </div>
              <div class="nav__item">
                <div
                  @click="scrollToSection('howToUse')"
                  class="desc hover-link"
                >
                  How to use
                </div>
              </div>
              <div class="nav__item">
                <div
                  @click="scrollToSection('categories')"
                  class="desc hover-link"
                >
                  Categories
                </div>
              </div>
              <div class="nav__item">
                <div @click="$parent.openContactModal" class="desc">
                  Contact
                </div>
              </div>
            </div>

            <ul class="nav">
              <li class="nav__item" @click="goToFaqPage">
                <div class="desc">Faq</div>
              </li>
              <template v-for="item in $parent.textPageList">
                <li class="nav__item nav__item-text-pages" :key="item.id">
                  <div @click="$parent.goToPage(item.url)" class="desc">
                    {{ item.title }}
                  </div>
                </li>
              </template>
              <li class="nav__item">
                <router-link to="/product-list" class="desc"
                  >Shop</router-link
                >
              </li>
            </ul>

            <div class="nav">
              <div class="nav__item">
                <div class="desc" v-if="$parent.settings.company_name">
                  {{ $parent.settings.company_name }}
                </div>
              </div>
              <div class="nav__item">
                <div class="desc small">
                  <span v-if="$parent.settings.company_address">{{
                    $parent.settings.company_address
                  }}</span>
                  <br />
                  <span v-if="$parent.settings.company_reg_number"
                    >Company number:
                    {{ $parent.settings.company_reg_number }}</span
                  >
                </div>
              </div>
              <div class="nav__item">
                <div class="desc small">
                  <a
                    :href="'mailto:' + $parent.settings.support_email"
                    v-if="$parent.settings.support_email"
                    >{{ $parent.settings.support_email }}</a
                  >
                </div>
                <div class="desc small">
                  <a
                    v-if="$parent.settings.support_phone"
                    :href="
                      'tel:' +
                      ($parent.settings.support_phone.replace(/[\s()-]/g, '') ||
                        '')
                    "
                    >{{ $parent.settings.support_phone }}</a
                  >
                </div>

                <div class="desc">
                  Support hours: Monday to Friday from 9AM to 5PM (UK timezone)
                </div>
                <div
                  class="social-links-wrapper"
                  v-if="$parent.socialLinks.length"
                >
                  <a
                    :href="link.url"
                    v-for="link in $parent.socialLinks"
                    class="link"
                    target="_blank"
                    v-bind:key="link.url"
                  >
                    <img :src="link.image" class="link-img" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="desc">
            *In order to use prompts, you must register on the appropriate
            platforms
          </div>
        </div>

        <div class="right">
          <router-link to="/" class="logo">
            <img src="./../images/logo.svg" class="img" />
          </router-link>
          <ul class="list">
            <li class="item">
              <img src="./../assets/pay/mc.svg" class="img mc" />
            </li>
            <li class="item">
              <img src="./../assets/pay/1.svg" class="img" />
            </li>
            <li class="item">
              <img src="./../assets/3ds.svg" class="img ds" />
            </li>
            <li class="item">
              <img src="./../assets/pci.svg" class="img pci" />
            </li>
          </ul>
        </div>
      </div>
      <div class="wrapper" v-if="$parent.settings.copyright">
        <div class="copyright">{{ $parent.settings.copyright }}</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: [],
  data: function () {
    return {};
  },
  methods: {
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
    goToFaqPage() {
      this.$router.push({ path: "/faq" });
    },
    setStableDiffusionModel() {
      let model = this.$parent.models.find((obj) => obj.id === 1);
      this.$emit("setActiveModel", model);
    },
  },
  mounted() {},
};
</script>
